import { Card, CardFooter, CardHeader, TrackScrolledIntoView } from '@homebotapp/hb-react-component-catalog'
import { Waypoint } from 'react-waypoint'
import { useSelector } from 'react-redux'
import QuestionSingle from '../Questions/Single'
import { RootState } from '../../../types/rootState'
import { useTrackingContext } from '../../../providers/tracking'
import { TrackingEventConstants } from '../../../constants/tracking'
import { useTrackingDebounceSetters } from '../../../hooks/tracking'
import { PmiProvidedModuleDetails } from './PmiProvidedModuleDetails'
import { PmiProvidedModuleHeaderText } from './PmiProvidedModuleHeaderText'
import { CUSTOMER_MESSAGES } from '../../../constants/customerMessages'
import { PmiProvidedModuleProgressBar } from './PmiProvidedModuleProgressBar'
import { PmiProvidedModuleTimelineForRemovalRainbowText } from './PmiProvidedModuleTimelineForRemovalRainbowText'
import { HOMEOWNER_DIGEST_PMI_MODULE } from '../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'
import { MORTGAGE_INSURANCE } from '../../../constants/document_ids'

export const PmiProvidedModule = () => {
  const { trackingClient } = useTrackingContext()
  const ltcvPercent = useSelector<RootState, number | null>(state => state.pmi.ltcvPercent)
  const showPmiProvidedModule = useSelector<RootState, boolean | null>(state => state.pmi.showPmiProvidedModule)
  const [trackModuleViewed] = useTrackingDebounceSetters(
    () =>
      trackingClient?.moduleViewed({
        module_name: TrackingEventConstants.PRIVATE_MORTGAGE_INSURANCE
      })
  )

  if (!showPmiProvidedModule || ltcvPercent === null) {
    return null
  }

  return (
    <TrackScrolledIntoView
      tracking={{
        guid: '5786wPJJzjcFjVcRXACzss',
        ui_context: HOMEOWNER_DIGEST_PMI_MODULE,
        descriptor: 'PMI Provided Module'
      }}
    >
      <Card
        size='lg'
        overflow='hidden'
        data-qa='pmi-learn-more-module'
        id={MORTGAGE_INSURANCE}
        scrollMarginTop='var(--digest-module-scroll-margin-top)'
      >
        <CardHeader>
          <PmiProvidedModuleHeaderText />
        </CardHeader>
        <PmiProvidedModuleTimelineForRemovalRainbowText />
        <PmiProvidedModuleProgressBar ltcvPercent={ltcvPercent} />
        <PmiProvidedModuleDetails ltcvPercent={ltcvPercent} />
        <Waypoint onEnter={trackModuleViewed} />
        <CardFooter padding={4} backgroundColor='neutral.100'>
          <QuestionSingle
            topic={CUSTOMER_MESSAGES.MORTGAGE_INSURANCE.topic}
            topicKey={CUSTOMER_MESSAGES.MORTGAGE_INSURANCE.topicKey}
            question={CUSTOMER_MESSAGES.MORTGAGE_INSURANCE.message}
          />
        </CardFooter>
      </Card>
    </TrackScrolledIntoView>
  )
}
